import { render, staticRenderFns } from "./Publico.vue?vue&type=template&id=71de0c48&scoped=true"
import script from "./Publico.vue?vue&type=script&lang=js"
export * from "./Publico.vue?vue&type=script&lang=js"
import style0 from "./Publico.vue?vue&type=style&index=0&id=71de0c48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71de0c48",
  null
  
)

export default component.exports